import React, { useEffect } from 'react';
import DataPageHeader from './DataPageHeader';
import EmailDraftModal from './EmailDraftModal';
import { getValidToken } from '../../utils/msalTokenUtil';
import { getApiUrl, loginRequest } from '../../authConfig';

const TaxPortalLayout = ({ 
  title, 
  description, 
  taxEntries, 
  portalState, 
  isFluid = false,
  theme = 'default',
  children 
}) => {
  const {
    account, msalInstance, isInitialized, 
    dialNumber, setDialNumber, 
    refreshTrigger, 
    isDialerOpen, setIsDialerOpen,
    handleLogin, handleLogout,
    emailModalConfig, setEmailModalConfig
  } = portalState;
  // Monitor session health periodically
  useEffect(() => {
    if (!account || !isInitialized) return;

    const validateSession = async () => {
      try {
        const accessToken = await getValidToken(msalInstance, account);
        const response = await fetch(getApiUrl('/v1/ping'), {
          method: 'GET',
          headers: { Authorization: `Bearer ${accessToken}` },
        });

        if (response.status === 401 || response.status === 403) {
          throw new Error("Token/Session rejected by server API.");
        }
      } catch (err) {
        console.warn("Session validation failed, attempting to force re-login", err);
        try {
          await msalInstance.loginPopup(loginRequest || { scopes: ['User.Read'] });
        } catch (loginErr) {
          console.error("Forced re-login failed", loginErr);
        }
      }
    };

    validateSession(); // Validate on mount
    const intervalId = setInterval(validateSession, 30 * 60 * 1000); // Check every 30 minutes
    return () => clearInterval(intervalId);
  }, [account, isInitialized, msalInstance]);

  const content = (
    <>
      <DataPageHeader
        title={title}
        description={description}
        account={account}
        onLogin={handleLogin}
        onLogout={handleLogout}
        msalInstance={msalInstance}
        isInitialized={isInitialized}
        taxEntries={taxEntries}
        dialNumber={dialNumber}
        setDialNumber={setDialNumber}
        refreshTrigger={refreshTrigger}
        isDialerOpen={isDialerOpen}
        setIsDialerOpen={setIsDialerOpen}
        theme={theme}
      />
      {children}
      
      {emailModalConfig && (
        <EmailDraftModal 
          customerData={emailModalConfig.customer}
          action={emailModalConfig.action}
          taxType={emailModalConfig.taxType}
          customData={emailModalConfig.customData}
          msalInstance={msalInstance}
          account={account}
          onClose={() => setEmailModalConfig(null)}
        />
      )}
    </>
  );

  return (
    <div className={`d-flex position-relative page-with-dialer ${isDialerOpen ? 'dialer-open' : ''} ${theme === 'glass' ? 'glass-bg' : ''}`} style={theme === 'glass' ? {} : { minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      <div className="flex-grow-1 d-flex flex-column" style={{ minWidth: 0, transition: 'all 0.3s ease' }}>
        <div className="container-fluid py-4 px-3 px-lg-4 portal-content-container">
          {content}
        </div>
      </div>
    </div>
  );
};

export default TaxPortalLayout;
